import apiClient from '@u/apiClient'

import importActions from './actions.import'
import commandRunnerActions from './actions.commandRunner'
import GetTenantProdDatabaseDumpController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetTenantProdDatabaseDumpController'
import GetReleaseListController from '@/wayfinder/actions/App/Http/Controllers/Release/GetReleaseListController'
import GetReleaseByIdController from '@/wayfinder/actions/App/Http/Controllers/Release/GetReleaseByIdController'
import UpdateReleaseController from '@/wayfinder/actions/App/Http/Controllers/Release/UpdateReleaseController'
import CreateReleaseController from '@/wayfinder/actions/App/Http/Controllers/Release/CreateReleaseController'
import RestoreDumpController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/RestoreDumpController'

export default {
  ...importActions,
  ...commandRunnerActions,

  fetchDumpList({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTenantProdDatabaseDumpController.get())
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchReleaseList({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetReleaseListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchRelease({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetReleaseByIdController.get({ release: payload.release_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateRelease({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateReleaseController.put({ release: payload.release_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createRelease({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateReleaseController.post(), payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async dumpDb({ commit, getters }, payload) {
    console.log('dumpDb')
    await apiClient
      .get(`/api/sa-management/dump/direct`)
      .then(async (response) => {
        // console.log('res', response)
        if (response.data.success) {
          payload.successCallback()
        }
      })
      .catch(async (reason) => {
        console.error('fetchDumpList', reason)
      })
  },

  async restoreDump({ commit, getters }, payload) {
    console.log('in restore')
    await apiClient
      .route(RestoreDumpController.post(), { dump: payload.dump })
      .then(async (response) => {
        if (response.status === 200) {
          payload.successCallback(response.data.key)
        }
      })
      .catch(async (reason) => {
        console.error('fetchDumpList', reason)
      })
  }
}
